import React from 'react';
import './css/presentation.css';

const Presentation = () => {
  const handleDownload = (e) => {
    // Предотвращаем переход по умолчанию (если вдруг кто-то захочет сделать <a> вместо div)
    e.preventDefault();
    
    // Открываем в новой вкладке
    window.open('https://cloud.altcor.ru/altcor.pdf', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="presentation">
      <div className="container presentation-container">
        {/* Левый блок: текст */}
        <div className="presentation-content">
          <p className="presentation-text">
            С помощью передовых нейронных сетей (AI) наша программа 
            <strong> молниеносно сканирует файловую систему</strong>, выявляет конфиденциальную информацию 
            и <strong>надежно изолирует её</strong>. Управляйте найденными файлами через 
            <strong> стильный и интуитивно понятный веб-интерфейс</strong>, обеспечивая полный контроль 
            и безопасность. Простая установка, элегантный дизайн и мощная защита — всё, чтобы ваши данные 
            были под надежным замком. <strong>Защитите своих клиентов с ALTCOR!</strong>
          </p>
          <p className="presentation-footer">
            Российская разработка, внесённая в Единый реестр отечественного ПО № 29212
          </p>
        </div>

        {/* Правый блок: кнопка */}
        <div className="presentation-button-wrapper">
          {/* Используем обычный div с role="button" для доступности */}
          <div
            className="presentation-button"
            onClick={handleDownload}
            onKeyDown={(e) => e.key === 'Enter' || e.key === ' ' ? handleDownload(e) : null}
            role="button"
            tabIndex={0}
            style={{ cursor: 'pointer' }}
          >
            Скачать презентацию
            {/* Маленькая иконка стрелочки (необязательно) */}
           
          </div>
        </div>
      </div>
    </section>
  );
};

export default Presentation;